import React from "react";
import { Link } from "react-router-dom";
import { Github, Linkedin } from "lucide-react";

function Navbar() {
    const handleNavClick = () => {
        const toggler = document.querySelector('.navbar-toggler');
        const navCollapse = document.getElementById('navbarNav');
        if (navCollapse && navCollapse.classList.contains('show')) {
            // remove show class to collapse without triggering click events
            navCollapse.classList.remove('show');
            if (toggler) {
                toggler.classList.add('collapsed');
                toggler.setAttribute('aria-expanded', 'false');
            }
        }
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark navbar-glass fixed-top">
            <div className="container">
                <Link className="navbar-brand fw-bold" to="/" onClick={handleNavClick}>
                    Smit Fataniya
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto align-items-center">
                        <li className="nav-item">
                            <Link className="nav-link" to="/about" onClick={handleNavClick}>About</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/project" onClick={handleNavClick}>Projects</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/skills" onClick={handleNavClick}>Skills</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/contact" onClick={handleNavClick}>Contact</Link>
                        </li>
                        
                        <li className="nav-item ms-2 d-flex gap-2">
                            <a className="social-btn" href="https://github.com/smitfataniya" target="_blank" rel="noopener noreferrer" title="GitHub">
                                <Github size={18} />
                            </a>
                            <a className="social-btn" href="https://linkedin.com/in/smit-fataniya" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                                <Linkedin size={18} />
                            </a>
                        </li>
                        
                        <li className="nav-item ms-2">
                            <a className="btn btn-sm btn-accent" href="/resume.pdf" target="_blank" rel="noopener noreferrer">Resume</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
